import { render, staticRenderFns } from "./OrderHoteRefuse.vue?vue&type=template&id=1881a2f0&scoped=true"
import script from "./OrderHoteRefuse.vue?vue&type=script&lang=js"
export * from "./OrderHoteRefuse.vue?vue&type=script&lang=js"
import style0 from "./OrderHoteRefuse.vue?vue&type=style&index=0&id=1881a2f0&prod&lang=scss&scoped=true"
import style1 from "./OrderHoteRefuse.vue?vue&type=style&index=1&id=1881a2f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1881a2f0",
  null
  
)

export default component.exports